<div class="corporate-ui" style="">
    <nav id="corp-banner" class="navbar navbar-toggleable-sm" role="navigation">
        <div class="navbar-header"><a id="homepage_link" class="navbar-brand" href="/">
            <img id="homepage_link_img" src="https://common.ebu.ch/corporateui/img/eye.png"></a>
        </div>
        <ul class="navbar-nav" id="left-menu">
            <li class="nav-item active hidden-xs-down">
                <a class="ebu" href="http://www.ebu.ch">EBU</a>
            </li>
            <li class="nav-item hidden-xs-down">
                <a class="eurovisionnet" href="http://www.eurovision.net" target="_blank">Eurovision.net</a>
            </li>
            <li class="nav-item hidden-xs-down">
                <a class="euroradionet" href="http://www.euroradio.net" target="_blank">Euroradio.net</a>
            </li>
            <li class="nav-item hidden-xs-down">
                <a class="ebutech" href="http://tech.ebu.ch" target="_blank">EBU
                Tech</a>
            </li>
            <li class="nav-item hidden-xs-down">
                <a class="workspace" href="https://workspace.ebu.ch" target="_blank">Workspace</a>
            </li>
            <li class="nav-item dropdown-contests-li" ngbDropdown>
                <a id="dropdown-contests" ngbDropdownToggle>
                    <i class="fa fa-bars"></i>
                    <span class="hidden-xs-down">Eurovision Contests</span>
                </a>
                <ul class="dropdown-menu" ngbDropdownMenu>
                    <li class="hidden-sm-up">
                        <a href="http://www.eurovision.net" target="_blank">Eurovision.net</a>
                    </li>
                    <li class="hidden-sm-up">
                        <a href="http://www.euroradio.net" target="_blank">Euroradio.net</a>
                    </li>
                    <li class="hidden-sm-up">
                        <a href="http://tech.ebu.ch" target="_blank">EBU Tech</a>
                    </li>
                    <li class="hidden-sm-up">
                        <a href="https://workspace.ebu.ch" target="_blank">Workspace</a>
                    </li>

                    <hr class="hidden-sm-up">

                    <li>
                        <a href="http://www.eurovision.tv/" target="_blank">Eurovision Song Contest</a>
                    </li>
                    <li>
                        <a href="http://www.junioreurovision.tv" target="_blank">Junior Eurovision Song Contest</a>
                    </li>
                    <li>
                        <a href="http://www.youngdancers.tv" target="_blank">Eurovision Young Dancers</a>
                    </li>
                    <li>
                        <a href="http://www.youngmusicians.tv" target="_blank">Eurovision Young Musicians</a>
                    </li>
                    <li>
                        <a href="http://www.rosedor.com" target="_blank">Rose d'Or Awards</a>
                    </li>
                </ul>
            </li>
        </ul>
        <div id="spring-cleaning-message"></div>
    </nav>
</div>


// WEBPACK FOOTER //
// ./src/app/corporate-ui-header/corporate-ui-header.component.html